module.exports = __webpack_public_path__ + "img/voucher-expired.fe42435f.svg";